<template>
<div>

  <el-row>
    <el-col :span="17">
  <!-- 面包屑导航区域-->
  <el-breadcrumb separator-class="el-icon-arrow-right">
    <el-breadcrumb-item :to="{ path: '/home' }">Homepage</el-breadcrumb-item>
    <el-breadcrumb-item>Production</el-breadcrumb-item>
    <el-breadcrumb-item>QTY Rolling Plan</el-breadcrumb-item>
  </el-breadcrumb>
</el-col>
  <el-col class="el-breadcrumb__inner" font-size="3px" :span="6">
    Updating Time: {{ this.updateTime }}
    </el-col>
  </el-row>
  <!--卡片视图区域-->

  <el-card>
    <el-form :model="formInline" class="demo-form-inline">
              <el-row>
                <el-col :span = "6">
              <el-form-item label="Brand:" label-width="115px">
                  <el-select v-model="formInline.brands" multiple collapse-tags
                    style="margin-left: 0px;"  filterable
                    placeholder="please choose">
                  <el-option
                  v-for="item in brandList"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
                  </el-form-item>
                  </el-col>
                  <el-col :span = "8">
                  <el-form-item label="Customer:" label-width="155px">
                      <el-select v-model="formInline.customers" multiple collapse-tags
                        style="margin-left: 0px;"
                        placeholder="please choose">
                      <el-option
                      v-for="item in this.customerList"
                      :key="item"
                      :label="item"
                      :value="item">
                    </el-option>
                  </el-select>
                      </el-form-item>
                      </el-col>
                      <el-col :span = "10">

                <el-form-item label="Sch Date:" label-width="115px">
                  <el-date-picker
                    v-model="formInline.schDate"  value-format="yyyy-MM-dd"
                    type="daterange"
                    range-separator="-"
                    start-placeholder="Start Date"
                    end-placeholder="End Date">
                  </el-date-picker>
                </el-form-item>
                </el-col>
                      </el-row>
                <el-row>
                  <el-col :span = "6">
                <el-form-item label="Status:" label-width="115px">
                  <el-select v-model="formInline.status" multiple collapse-tags
                        style="margin-left: 0px;"
                        placeholder="please choose">
                      <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                      <span style="float: left">{{ item.label }}</span>
                      <span style="float: right; margin-right: 30px; color: #8492a6; font-size: 13px">{{ item.value }}</span>
                    </el-option>
                  </el-select>
                </el-form-item>
                </el-col>
                <el-col :span = "8">
                  <el-form-item label="Delivery Address:" label-width="155px">
                    <el-select v-model="formInline.deliveryAddr" multiple collapse-tags
                          style="margin-left: 0px;"   filterable
                          placeholder="please choose">
                        <el-option
                          v-for="item in this.deliveryAddrList"
                          :key="item.code"
                          :label="item.code"
                          :value="item.code">
                          <span style="float: left">{{ item.code }}</span>
                          <span style="float: right; margin-right: 5px; color: #8492a6; font-size: 13px">{{ item.description }}</span>
                        </el-option>
                    </el-select>
                  </el-form-item>
                <!-- <el-form-item label="Delivery Address:" label-width="155px">
                  <el-select v-model="formInline.deliveryAddr" multiple collapse-tags
                        style="margin-left: 0px;"
                        placeholder="please choose">
                      <el-option
                      v-for="item in deliveryAddrArr"
                      :key="item.code"
                      :label="item.description"
                      :value="item.code">
                      <span style="float: left">{{ item.description }}</span>
                      <span style="float: right; margin-right: 30px; color: #8492a6; font-size: 13px">{{ item.code }}</span>
                    </el-option>
                  </el-select>
                </el-form-item> -->
                </el-col>
                <el-col :span = "10">
                <el-form-item >
                  <el-button type="primary" @click="onSubmit">Search</el-button>
                   <el-button type="primary" @click="exportToExcel">Excel</el-button>
                 </el-form-item>
                 </el-col>
        </el-row>
      </el-form>
      <div style="overflow: auto;width: 100%;">
      <table class="table-style" cellspacing=0 cellpadding=0>
          <tbody>
              <tr class="table-header">
                  <td colspan="2"></td>
                  <td v-for= "(item,index2) in allYymmWeekCntList" :colspan="item[1]" v-bind:key="index2">{{ item[0] }}</td>
                  <td>Total</td>
              </tr>
              <tr class="table-header">
              <td>Incoterm town</td>
              <td>Supplier</td>
              <td v-for= "(item,index) in allWeeksNbrList" v-bind:key="index">{{ item }}</td>
              <td></td>
              </tr>

              <template v-for= "(item,indexCbm) in cbmList">
              <tr v-for= "(suppler,index3) in item.supplier" v-bind:key="indexCbm + suppler.name + index3">
              <td v-if="index3==0" :rowspan="item.supplier.length">{{item.incotermTown}} </td>
              <td>{{suppler.name}}</td>
              <td v-for= "(week,index1) in suppler.weeks" :key="'2-'+index1">
                <template v-if="checkZero(Math.round(week.value * 10) / 10) === '' && checkZero(week.qtyValue) === ''">
                 </template>
                <template v-else>{{ numFormat(checkZero(week.qtyValue)) }}
                  </template>
                  </td>
              <td>
              <template v-if="checkZero(Math.round(suppler.total * 10) / 10) === '' && checkZero(suppler.qtyTotal) === ''">
               </template>
              <template v-else>{{ numFormat(checkZero(suppler.qtyTotal)) }}
                </template>
                </td>
              </tr>

              <tr v-bind:key="item.incotermTown">
              <td class="sub-total">{{ item.incotermTown }} Total</td>
              <td class="sub-total"></td>
              <td class="sub-total" v-for= "(cityTotal,index) in item.total" v-bind:key="index">
              <template v-if="checkZero(Math.round(cityTotal * 10) / 10) === '' && checkZero(item.qtyTotal[index]) === ''">
               </template>
              <template v-else>{{ numFormat(checkZero(item.qtyTotal[index])) }}
                </template>
              </td>
              <td class="sub-total">
              <template v-if="checkZero(Math.round(item.cityTotal * 10) / 10) === '' && checkZero(item.cityQtyTotal) === ''">
               </template>
              <template v-else>{{ numFormat(checkZero(item.cityQtyTotal)) }}
                </template>
              </td>
              </tr>
              </template>

              <tr class="total">
                <td class="total">Total</td>
                <td></td>
                <td v-for= "(allCityWeekTotalone,index) in allCityWeekTotal" v-bind:key="'1-'+index">{{ numFormat(allCityWeekQtyTotal[index])}}</td>
                <td class="total">
                  <template v-if="checkZero(Math.round(valueTotal * 10) / 10) === '' && checkZero(valueQtyTotal) === ''">
                   </template>
                  <template v-else>{{ numFormat(checkZero(valueQtyTotal)) }}
                    </template>
                </td>
              </tr>
              </tbody>
              </table>
              </div>

  </el-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      formInline: {
        schDate: '',
        status: [],
        deliveryAddr: []
        // page: 1,
        // rows: 100
      },
      userName: '',
      cbmList: [],
      allYymmWeekCntList: [],
      allWeeksNbrList: [],
      allCityWeekTotal: [],
      allCityWeekQtyTotal: [],
      valueTotal: '',
      valueQtyTotal: '',
      brandList: [],
      customerList: [],
      statusList: '',
      deliveryAddrList: [],
      updateTime: '',
      brandParam: {
        userName: '',
        userType: ''
      },
      options: [{
        value: 'DEV',
        label: 'Development',
        description: 'Development'
      }, {
        value: 'HLD',
        label: 'On Hold',
        description: 'On Hold'
      }, {
        value: 'LHK',
        label: 'Loading Hong Kong',
        description: 'Loading Hong Kong'
      }, {
        value: 'LSH',
        label: 'Loading Shanghai',
        description: 'Loading Shanghai'
      }, {
        value: 'LXI',
        label: 'Loading Xiamen',
        description: 'Loading Xiamen'
      }, {
        value: 'LYA',
        label: 'Loading Yantian',
        description: 'Loading Yantian'
      }, {
        value: 'NEW',
        label: 'New Order',
        description: 'New Order'
      }, {
        value: 'OKC',
        label: 'Confirmed to Close on arrival',
        description: 'Confirmed to Close on arrival'
      }, {
        value: 'OLO',
        label: 'On Line QC Pass',
        description: 'On Line QC Pass'
      }, {
        value: 'ONG',
        label: 'On Going Production',
        description: 'On Going Production'
      }, {
        value: 'PND',
        label: 'Pending for Approval',
        description: 'Pending for Approval'
      }, {
        value: 'PNO',
        label: 'Produce with Next Order',
        description: 'Produce with Next Order'
      }, {
        value: 'REJ',
        label: 'Reject',
        description: 'Reject'
      }, {
        value: 'RHK',
        label: 'Ready Hong Kong',
        description: 'Ready Hong Kong'
      }, {
        value: 'RSH',
        label: ' Ready Shanghai',
        description: ' Ready Shanghai'
      }, {
        value: 'RTC',
        label: 'Request to Close',
        description: 'Request to Close'
      }, {
        value: 'RXI',
        label: 'Ready Xiamen',
        description: 'Ready Xiamen'
      }, {
        value: 'RYA',
        label: 'Ready Yantian',
        description: 'Ready Yantian'
      }, {
        value: 'SFR',
        label: 'Shipment ready from France',
        description: 'Shipment ready from France'
      }, {
        value: 'SME',
        label: 'Shipment ready from Mexico',
        description: 'Shipment ready from Mexico'
      }, {
        value: 'TLB',
        label: 'Ready for Transfer to LB',
        description: 'Ready for Transfer to LB'
      }, {
        value: 'TYF',
        label: 'Ready for Transfer to Yufan',
        description: 'Ready for Transfer to Yufan'
      }, {
        value: 'WFC',
        label: 'Waiting for confirmation',
        description: 'Waiting for confirmation'
      }
      ],
      deliveryAddrArr: [{
        code: 'AD_2',
        description: 'IP Dayton'
      // }, {
      //   code: 'AD_1',
      //   description: 'IP New York'
      }, {
        code: 'INT',
        description: 'IP Dayton'
      }, {
        code: 'TSM',
        description: 'TSM'
      }, {
        code: 'ENDEK',
        description: 'TSM'
      }, {
        code: 'FTZ',
        description: 'FTZ FG'
      }, {
        code: 'FTZ_1',
        description: 'FTZ COMPO'
      }, {
        code: 'LIFE',
        description: 'LB'
      }, {
        code: 'YFF',
        description: 'YF'
      }, {
        code: '3Star',
        description: '3Star'
      }, {
        code: 'CHI',
        description: 'ChiKwong'
      }, {
        code: 'EUROS',
        description: 'EUROS'
      }
      ]
    }
  },
  created () {
    this.userName = window.sessionStorage.getItem('username')
    this.formInline.token = window.sessionStorage.getItem('token')
    this.brandParam.userName = this.userName
    this.brandParam.userType = window.sessionStorage.getItem('userType')
    this.getBrands()
    this.getCustomers()
    this.getCbms()
    this.getDeliveryAddrList()
  },
  methods: {
    async getCustomers () {
      const { data: res } = await this.$http.get('/show/customerList')
      this.customerList = await res.customers
    },
    async getDeliveryAddrList () {
      const { data: res } = await this.$http.get('/show/deliveryAddrList', { params: this.brandParam })
      var deliveryArr = await res.deliveryAddr
      for (var i = 0; i < deliveryArr.length; i++) {
        var flag = false
        for (var j = 0; j < this.deliveryAddrArr.length; j++) {
          if (deliveryArr[i].toUpperCase() === this.deliveryAddrArr[j].code.toUpperCase()) {
            flag = true
            this.deliveryAddrList.push({ code: deliveryArr[i], description: this.deliveryAddrArr[j].description })
            break
          }
        }
        if (!flag) {
          this.deliveryAddrList.push({ code: deliveryArr[i], description: '' })
        }
      }
    },
    async getBrands () {
      const { data: res } = await this.$http.get('/common/brandList', { params: this.brandParam })
      this.brandList = await res.brands
    },
    async getCbms () {
      this.schDateStart = ''
      this.schDateEnd = ''

      if (this.formInline.schDate) {
        if (this.formInline.schDate.length) {
          this.schDateStart = this.formInline.schDate[0]
          this.schDateEnd = this.formInline.schDate[1]
          this.formInline.schDate = [...this.formInline.schDate].join(',')
        }
      }

      var customerStr = ''

      if (this.formInline.customers && this.formInline.customers.length) {
        this.formInline.customers = [...this.formInline.customers].join(',')
        customerStr = this.formInline.customers
      }

      var brandStr = ''

      if (this.formInline.brands && this.formInline.brands.length) {
        this.formInline.brands = [...this.formInline.brands].join(',')
        brandStr = this.formInline.brands
      }

      var statusStr = ''

      if (this.formInline.status && this.formInline.status.length) {
        this.formInline.status = [...this.formInline.status].join(',')
        statusStr = this.formInline.status
      }

      var deliveryAddrStr = ''

      if (this.formInline.deliveryAddr && this.formInline.deliveryAddr.length) {
        this.formInline.deliveryAddr = [...this.formInline.deliveryAddr].join(',')
        deliveryAddrStr = this.formInline.deliveryAddr
      }

      const { data: res } = await this.$http.get('/show/cbmList', { params: this.formInline })
      this.allYymmWeekCntList = await res.allYymmWeekCntList
      this.allWeeksNbrList = await res.allWeeksNbrList
      this.allCityWeekTotal = await res.allCityWeekTotal
      this.valueTotal = await res.total
      this.cbmList = await res.cbmList
      this.allCityWeekQtyTotal = await res.allCityWeekQtyTotal
      this.valueQtyTotal = await res.qtyTotal
      this.updateTime = await res.createTime
      await this.$set(this.formInline, 'schDate', [this.schDateStart, this.schDateEnd])

      if (customerStr !== '') {
        await this.$set(this.formInline, 'customers', customerStr.split(','))
      }

      if (brandStr !== '') {
        await this.$set(this.formInline, 'brands', brandStr.split(','))
      }

      if (statusStr !== '') {
        await this.$set(this.formInline, 'status', statusStr.split(','))
      }

      if (deliveryAddrStr !== '') {
        await this.$set(this.formInline, 'deliveryAddr', deliveryAddrStr.split(','))
      }
    },
    onSubmit () {
      console.log('submit!')
      this.formInline.page = 1
      this.getCbms()
    },
    exportToExcel () {
      window.open('https://www.myirequest.com:8081/show/exportQtySchedule?brands=' + this.formInline.brands + '&customers=' + this.formInline.customers + '&schDate=' + this.formInline.schDate + '&status=' + this.formInline.status +
       '&deliveryAddr=' + this.formInline.deliveryAddr + '&token=' + encodeURIComponent(this.formInline.token) // + '&poDate=' + this.formInline.poDate, '_parent')
      , '_parent')
    },
    async getStatusDeliveryAddr () {
      const { data: res } = await this.$http.get('/show/statusDeliveryAddrList')
      this.statusList = await res.statusList
      console.log(this.statusList)
      // this.deliveryAddrList = await res.deliveryAddrList
    },
    checkSlash (str) {
      if (str === null || str === '' || str === '/') {
        return
      }
      return str
    },
    numFormat (numrc) {
      // var numrc = row[column.property]
      if (numrc === null || numrc === '') {
        return
      }
      var result = ''
      var counter = 0

      numrc = (numrc || 0).toString()
      for (var i = numrc.length - 1; i >= 0; i--) {
        counter++
        result = numrc.charAt(i) + result
        if (!(counter % 3) && i !== 0) {
          result = ' ' + result
        }
      }
      return result
    },
    checkZero (value) {
      if (value === 0 || value === 0.0) {
        return ''
      }
      return value
    }
  }
}
</script>

<style lang="less" scoped="scoped">
  .table-style {
    width: 100%;
    border: 0.1px solid #ddd;
    border-collapse: collapse;
    font-size: 12px;
    font-family:Consolas;
    line-height: 35px;
    color: #606266;
  }
  .table-header {
    // background-color: rgb(192,192,192);
    font-weight: 500;
    line-height: 45px;
    // background-color: rgb(214,237,239);
    border: 1px solid #ddd;
  }
  td {
    border: 0.1px solid #ddd;
    // color: #8E2323;
  }
  .sub-total {
    background-color: rgb(230,230,230);
    // color: rgb(254,82,107);
  }
  .total {
    background-color: rgb(192,192,192);
    line-height: 39px;
  }

</style>
